module.exports = __webpack_public_path__ + "img/玄参.8802b22c.jpg";